import React, { useEffect } from 'react';
import moment from 'moment';
import AuctionCard from './AuctionCard';
import './upcomingAuctions.scss';

const UpcomingAuction = ({
  auctions,
  handleClick,
  fullWidth,
  title,
  auctionDate,
  vertical,
  paddingTop,
}) => {
  let className = '';
  className += fullWidth ? 'text-section-web' : '';
  className += vertical ? '' : ' horizontalScroll';
  useEffect(() => {
    function handleContextMenu(e) {
      e.preventDefault(); // prevents the default right-click menu from appearing
    }
    // add the event listener to the component's root element
    const rootElement = document.getElementById('my-component');
    rootElement.addEventListener('contextmenu', handleContextMenu);
    // remove the event listener when the component is unmounted

    return () => {
      rootElement.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  if (typeof window !== 'undefined') {
    document.addEventListener('contextmenu', e => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }
  return (
    <div
      className="upcoming-auctions"
      id="my-compoenent"
      style={{ paddingTop }}
    >
      <div className="titleSection">
        {title && (
          <div>
            {title && <h2>{title}</h2>}
            {auctionDate && (
              <h5>{moment(auctionDate).format('DD MMMM YYYY')}</h5>
            )}
          </div>
        )}
      </div>
      <div className={`text-section ${className}`}>
        {auctions?.length > 0 &&
          auctions.map((auction, index) => (
            <AuctionCard
              key={index}
              img={auction.img}
              location={auction.location}
              date={auction.date}
              time={auction.time}
              buttons={auction.eventDetailButtons}
              path={auction.path}
              info={auction.info}
              subInfo={auction.subInfo}
              mailAddress={auction.mailAddress}
              handleClick={handleClick}
              fullWidth={fullWidth}
            />
          ))}
      </div>
    </div>
  );
};

UpcomingAuction.defaultProps = {
  fullWidth: false,
  vertical: true,
  paddingTop: '58px',
};

export default UpcomingAuction;
